/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Form from "../../../../components/Form";
import { get, isEmpty } from "lodash";
import {
  createGrades,
  createGradesOrganize,
  updateGrades,
} from "../../../../apis/companies/grade";
import useForm from "../../../../hooks/useForm";
import Modal, { ModalHeader } from "../../../../components/Modal";
import { useDispatch, } from "react-redux";
import { getStoreCompanies } from "../../../../store/actions";

const Grade = ({ list, mode = "create", open, setOpen, treeData, preSort, isTax = false }) => {
  const dispatch = useDispatch();
  const [formFields, setFormFields] = useState([]);

  useEffect(() => {
    setFormFields([
      [{ title: "직급", key: "name", type: "input", required: true }],
      [{ title: "코드", key: "code", type: "input", required: true }],
    ]);
  }, []);

  useEffect(() => {
    setValues({
      name: get(list, "title") || "",
      code: get(list, "code") || "",
      sort: preSort + 1 || 0,
    });
  }, [list, preSort]);

  const validate = ({ name, code }) => {
    let errors = {};

    if (!name) errors.name = "직급은 필수입니다.";
    if (!code) errors.code = "코드는 필수입니다.";

    return errors;
  };

  const _submit = (form) => {
    if (mode === "create") {
      const realData = treeData.filter((d) => d.key !== "unspecified");
      if (isEmpty(realData)) {
        createGrades({ ...form, isTax }).then(() => {
          setOpen(false);
          reset();
          dispatch(getStoreCompanies());
        });
      } else {
        const createForm = {
          ...form,
          sort: preSort + 1,
          isTax,
        };
        const _treeData = treeData;
        const changeData = _treeData.filter((data) => data.sort >= form.sort);
        const orgData = {
          grades: changeData.map((grade) => ({
            gradeIdx: grade.key,
            sort: grade.sort + 1,
          })),
          isTax,
        };

        createGrades(createForm).then(() => {
          createGradesOrganize(orgData).then(() => {
            setOpen(false);
            reset();
            dispatch(getStoreCompanies());
          });
        });
      }
    }

    if (mode === "update") {

      const updateForm = {
        ...form,
        isTax
      };
      updateGrades(get(list, "key"), updateForm).then((res) => {
        setOpen(false);
        reset();
        dispatch(getStoreCompanies());
      });
    }
  };
  const { form, setValues, errors, handleOnChange, handleSubmit, reset } =
    useForm(
      {
        name: "",
        code: "",
        sort: null,
      },
      _submit,
      validate
    );

  const cancel = (e) => {
    e.preventDefault();
    setOpen(false);
    reset();
  };

  return (
    <Modal size="md" isOpen={open} close={cancel}>
      <div className="grade-write">
        <ModalHeader>직급 {mode === "create" ? "작성" : "수정"}</ModalHeader>
        <Form
          fields={formFields}
          form={form}
          onChange={handleOnChange}
          submit={handleSubmit}
          cancel={cancel}
          errors={errors}
        />
      </div>
    </Modal>
  );
};

export default Grade;
